import React, { useContext } from "react";
import { Checkbox, DatePicker } from "antd";
import moment from "moment";
import { CalendarOutlined } from "@ant-design/icons";
import PremiumTag from "../Billing/PremiumTag";
import { RootContext } from "../../RootContextProvider";

const { RangePicker } = DatePicker;

const PlanLink = ({
  isScheduled,
  setIsScheduled,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
}) => {
  const { account } = useContext(RootContext);
  // const [disabledEndDate, setDisabledEndDate] = useState();

  let locale = {
    lang: {
      locale: "fr_FR",
      placeholder: "Choisir date",
      rangePlaceholder: ["Date de début", "Date de fin"],
      today: "Aujourd'hui",
      now: "Maintenant",
      backToToday: "Back to today",
      ok: "Ok",
      clear: "Clear",
      month: "Mois",
      year: "Année",
      timeSelect: "Choisir horaires",
      dateSelect: "Choisir date",
      monthSelect: "Choisir mois",
      yearSelect: "Choisir année",
      decadeSelect: "Choisir décénnie",
      yearFormat: "YYYY",
      dateFormat: "D/M/YYYY",
      dayFormat: "D",
      dateTimeFormat: "D/M/YYYY HH:mm",
      monthFormat: "MMMM",
      monthBeforeYear: true,
      previousMonth: "Previous month (PageUp)",
      nextMonth: "Next month (PageDown)",
      previousYear: "Last year (Control + left)",
      nextYear: "Next year (Control + right)",
      previousDecade: "Last decade",
      nextDecade: "Next decade",
      previousCentury: "Last century",
      nextCentury: "Next century",
    },
    timePickerLocale: {
      placeholder: "Choisir horaires",
    },
    dateFormat: "YYYY-MM-DD",
    dateTimeFormat: "YYYY-MM-DD HH:mm",
    weekFormat: "YYYY-wo",
    monthFormat: "YYYY-MM",
  };

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().endOf("day");
  };

  const onChange = (value, dateString) => {
    if (!value) {
      console.log("removing states");
      setStartDate();
      setEndDate();
    }
  };

  const onOk = (value, dateString) => {
    if (value[0]) {
      setStartDate(moment(value[0]));
    }
    if (value[1]) {
      setEndDate(moment(value[1]));
    }
  };

  return (
    <div className="plan-link-container">
      <Checkbox
        onChange={() => {
          setIsScheduled(!isScheduled);
        }}
        checked={isScheduled}
        disabled={account.IsPaying ? false : true}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <CalendarOutlined />{" "}
          <span style={{ marginLeft: "5px" }}>Planifier le lien</span>
          {account.IsPaying ? (
            ""
          ) : (
            <div className="premium-block">
              <PremiumTag size="medium" hasIcon={false} />
            </div>
          )}
        </div>
      </Checkbox>
      {isScheduled ? (
        <>
          <div className="datepicker-container">
            <div className="period">
              <span>Sélectionnez les dates de diffusion</span>
              {/* <DatePicker
                disabledDate={disabledDate}
                onChange={(dateString) => {
                  if (dateString) {
                    setStartDate(moment(dateString));
                    setDisabledEndDate(
                      moment(dateString) &&
                        moment(dateString) < moment().endOf("day")
                    );
                  } else {
                    setStartDate();
                  }
                }}
                locale={locale}
                showTime
                size="default"
                value={startDate}
                format="YYYY-MM-DD HH:mm"
              /> */}

              <RangePicker
                disabledDate={disabledDate}
                showTime={{ format: "HH:mm" }}
                locale={locale}
                format="YYYY-MM-DD HH:mm"
                size="default"
                onChange={onChange}
                onOk={onOk}
                value={[startDate, endDate]}
              />
            </div>
          </div>
          <div className="notice">
            Les horaires sont basées sur le fuseau UTC+1 Paris.
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default PlanLink;
